const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  BASE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/medium/',
  DEFAULT_LANGUAGE: 'en-us',
  CACHE_NAME: new Date().toISOString(),
  DATABASE_NAME: 'MakanDuls-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'MakanDuls',
  // WEB_SOCKET_SERVER: 'wss://estaurant-api.dicoding.dev/review',
};

export default CONFIG;
